import { get } from "lodash"

export const getForecasts = state => get(state, "global.data.forecasts.data.forecasts", [])
